import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/IndexView.vue'
import WorkbenchView from '../views/WorkbenchView.vue'
import WorkbenchMain from '../components/workbench/WorkbenchMain.vue'
import ProcessTaskView from '../views/ProcessTaskView.vue'
import DetectLayout from '../views/DetectLayout.vue'
import DetectView from '../views/DetectView.vue'
import DetectReportPage from '../views/DetectReportPage.vue'
import PptLayout from '../views/PptLayout.vue'
import PptView from '../views/PptView.vue'
import LiteratureLayout from '../views/LiteratureLayout.vue'
import LiteratureView from '../views/LiteratureView.vue'
import WordSlimLayout from '../views/WordSlimLayout.vue'
import WordSlimView from '../views/WordSlimView.vue'
import ImageAigcLayout from '../views/ImageAigcLayout.vue'
import ImageAigcView from '../views/ImageAigcView.vue'
import LoginRedirectView from '../views/LoginRedirectView.vue'
import WeChatCallbackView from '../views/WeChatCallbackView.vue'
import InviteView from '../views/InviteView.vue'
import TermsView from '../views/TermsView.vue'
import PrivacyView from '../views/PrivacyView.vue'
import PricingView from '../views/PricingView.vue'
import FaqView from '../views/FaqView.vue'
import PortalAboutView from '../views/PortalAboutView.vue'
import MarketingFeatureLandingView from '../views/MarketingFeatureLandingView.vue'
import { captureInviteFromRoute } from '@/utils/invite'
import { applyRouteSeo } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView
  },
  {
    path: '/index',
    redirect: () => ({ path: '/', query: {} })
  },
  {
    path: '/workbench',
    component: WorkbenchView,
    children: [
      {
        path: '',
        name: 'workbench',
        component: WorkbenchMain
      },
      {
        path: 'task',
        name: 'process-task',
        component: ProcessTaskView
      },
      {
        path: 'invite',
        name: 'workbench-invite',
        component: InviteView
      }
    ]
  },
  {
    path: '/detect',
    component: DetectLayout,
    children: [
      {
        path: '',
        name: 'detect',
        component: DetectView
      },
      {
        path: 'report',
        name: 'detect-report',
        component: DetectReportPage
      }
    ]
  },
  {
    path: '/ppt',
    component: PptLayout,
    children: [
      {
        path: '',
        name: 'ppt',
        component: PptView
      }
    ]
  },
  {
    path: '/literature',
    component: LiteratureLayout,
    children: [
      {
        path: '',
        name: 'literature',
        component: LiteratureView
      }
    ]
  },
  {
    path: '/word-slim',
    component: WordSlimLayout,
    children: [
      {
        path: '',
        name: 'word-slim',
        component: WordSlimView
      }
    ]
  },
  {
    path: '/image-aigc',
    component: ImageAigcLayout,
    children: [
      {
        path: '',
        name: 'image-aigc',
        component: ImageAigcView
      }
    ]
  },
  {
    path: '/reduce-aigc',
    name: 'reduce-aigc',
    component: MarketingFeatureLandingView
  },
  {
    path: '/reduce-plagiarism',
    name: 'reduce-plagiarism',
    component: MarketingFeatureLandingView
  },
  {
    path: '/dual-reduction',
    name: 'dual-reduction',
    component: MarketingFeatureLandingView
  },
  {
    path: '/academic-polish',
    name: 'academic-polish',
    component: MarketingFeatureLandingView
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: PricingView
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/about',
    name: 'about',
    component: PortalAboutView
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginRedirectView
  },
  {
    path: '/login/callback',
    name: 'login-callback',
    component: WeChatCallbackView
  },
  {
    path: '/register',
    redirect: to => ({ path: '/login', query: to.query })
  },
  {
    path: '*',
    redirect: () => ({ path: '/', query: {} })
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash, behavior: 'smooth' })
        }, 320)
      })
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  captureInviteFromRoute(to)
  applyRouteSeo(to)
  next()
})

export default router
